import { FormField } from '@/components/ui/Form';
import { Checkbox, Form, FormInput, FormItem, FormLabel, MultiSelect } from '@/components/wm';
import { getOptionsFromJson, getStoreResource } from '@/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import debounce from 'lodash/debounce';
import React, { useEffect, useMemo, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export function Properties({ data, onChangeField, onCompleted }) {
    const formSchema = z.object({
        active: z.boolean().default(false),
        name: z.string().min(1, 'Name is required'),
        userIds: z.array(z.string()).optional()
    });

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            active: data.active || false,
            name: data.name || '',
            userIds: data.userIds || []
        },
        mode: 'onBlur'
    });

    const debouncedTriggers = useRef({
        name: debounce(() => form.trigger('name'), 600)
    });

    const userOptions = useMemo(() => {
        const users = getStoreResource('users') || [];
        return getOptionsFromJson(users);
    }, []);

    useEffect(() => {
        onCompleted(form.formState.isValid);
    }, [form.formState.isValid]);

    useEffect(() => {
        return () => {
            Object.values(debouncedTriggers.current).forEach(fn => fn.cancel());
        };
    }, []);

    return (
        <Form className="tw-ml-1" {...form}>
            <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>{ i18next.t('common.name').capitalize()}</FormLabel>
                        <FormInput
                            {...field}
                            onChange={e => {
                                const val = e.target.value;

                                field.onChange(val);
                                debouncedTriggers.current.name();
                                if (onChangeField) {
                                    onChangeField('name')(val);
                                }
                            }}
                        />
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="active"
                render={({ field }) => (
                    <FormItem>
                        <Checkbox checked={!!field.value} label={i18next.t('glossary.active').capitalize()}
                            onCheckedChange={ checked => {
                                field.onChange(checked);
                                if (onChangeField) {
                                    onChangeField('active')(checked);
                                }
                            }
                            }/>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="userIds"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>{ i18next.t('common.notifications').capitalize()}</FormLabel>
                        <MultiSelect
                            defaultValue={field.value}
                            onValueChange={vals => {
                                field.onChange(vals);
                                if (onChangeField) {
                                    onChangeField('userIds')(vals);
                                }
                            }}
                            options={userOptions}
                            variant="secondary"
                        />
                    </FormItem>
                )}
            />
        </Form>
    );
}
